module.exports = __webpack_public_path__ + "img/singup11.6a5eea5e.jpg";